import React, { useMemo, useState, useEffect, useRef } from "react";
import { autosys_apply_actions } from "../../helpers/GlobalOptions";
import SelectInput from "../common/SelectInput";
import TextAreaFieldGroup from "../common/TextAreaFieldGroup";
import styled from "styled-components";
import useFetch from "../../hooks/useFetch";
import TextInputModal from "../common/TextInputModal";
import { Checkbox, Radio, Spin } from "antd";
import { DebounceSelect } from "../common";
import errorHandler from "../../helpers/ErrorHandler";
import Axios from "axios";
import {
  IconChevronDownSolid,
  IconChevronUpSolid,
  IconTrash,
} from "../Layout/Icons";
import { AiFillPlusCircle } from "react-icons/ai";
import { CheckBoxInput } from "../common/Buttons";
import AntdConfirm from "../../helpers/AntdConfirm";

const initialStateVariables = {
  id: null,
  type: "goods",
  quantity: 1,
  product_name: "",
  product_price: "",
  product_reference: "",
  barcode: "",
  id_product: "",
  rivile_code: "",
  weight_from: 0,
};

const AutosysApplyAction = ({
  apply_action,
  parameters,
  setValue,
  errors,
  order_shop_id,
}) => {
  const setParameters = (value) => {
    setValue((prev) => ({
      ...prev,
      parameters: {
        ...prev.parameters,
        ...value,
      },
    }));
  };
  return (
    <div>
      {autosys_apply_actions.map((d) => {
        const active = apply_action == d.value;
        return (
          <ApplyActionItemStyled
            className="mb-2"
            active={active}
            onClick={() => {
              if (active) return;
              let parameters_builder = {};
              if (d.value == parameters?.type) return;
              if (d.value == "auto_comment") {
                parameters_builder = {
                  comment_state_id: undefined,
                  message: "",
                };
              } else if (d.value == "add_supplying") {
                parameters_builder = {
                  qty: 1,
                  supplier_id: "",
                  days: "",
                };
              } else if (d.value == "add_additional_good") {
                parameters_builder = { data: [] };
                // type: "auto_comment",
              } else if (d.value == "change_courier") {
                parameters_builder = {
                  carrier_id: null,
                };
              } else if (d.value == "change_sku") {
                parameters_builder = {
                  qty: "",
                  price: "",
                  sku: "",
                  price_from_pim: false,
                };
              }

              setValue((prev) => ({
                ...prev,
                apply_action: d.value,
                parameters: parameters_builder,
              }));
            }}
          >
            <div className={`${active ? "block-header" : ""} pl-3 py-2`}>
              <Radio checked={active}>
                <span
                  className={`text-xs text-font font-semi-bold`}
                  style={{
                    color: active ? "#03b0f7" : "#6C6C6C",
                  }}
                >
                  {d.label}
                </span>
              </Radio>
            </div>

            {active && (
              <div className="p-2">
                {d.value == "auto_comment" && (
                  <CommentState
                    parameters={parameters}
                    setParameters={setParameters}
                  />
                )}
                {d.value == "auto_comment_note" && (
                  <CommentNote
                    parameters={parameters}
                    setParameters={setParameters}
                  />
                )}
                {d.value == "add_supplying" && (
                  <AddSupplying
                    parameters={parameters}
                    setParameters={setParameters}
                  />
                )}
                {d.value == "add_additional_good" && (
                  <AdditionalGood
                    parameters={parameters}
                    setParameters={setParameters}
                    order_shop_id={order_shop_id}
                  />
                )}
                {d.value == "change_courier" && (
                  <ChangeCourier
                    parameters={parameters}
                    setParameters={setParameters}
                    order_shop_id={order_shop_id}
                  />
                )}
                {d.value == "change_sku" && (
                  <ChangeSku
                    parameters={parameters}
                    setParameters={setParameters}
                    errors={errors}
                  />
                )}
              </div>
            )}
          </ApplyActionItemStyled>
        );
      })}
    </div>
  );
};

const ChangeSku = ({ parameters, setParameters, errors }) => {
  return (
    <div>
      <DebounceSelect
        labelInValue={false}
        label="SKU"
        required={true}
        showSearch={true}
        value={parameters.sku || undefined}
        placeholder={"Type to search"}
        fetchOptions={async (value) => {
          try {
            // imti tik esancius
            const api_url = `/api/v1/products/meilisearch_products.json?q[title_or_identifier_i_cont_any]=${value}`;
            const { data } = await Axios.get(api_url);
            const valArr = data?.data || [];
            return (
              valArr.map((e) => ({
                ...e,
                value: e.identifier,
                label: `${e.identifier} - ${e.title}`,
              })) || []
            );
          } catch (err) {
            errorHandler(err);
            return [];
          }
        }}
        onChange={(sku, value) => {
          console.log({ sku, value });
          setParameters({
            sku,
            qty: 1,
            price: value.product_price,
          });
        }}
        style={{
          width: "100%",
        }}
        error={errors.sku}
      />
      <div className="row">
        <div className="col-12">
          <TextInputModal
            text="Quantity"
            value={parameters.qty}
            required={true}
            onChange={(e) => {
              const qty = e.target.value;
              setParameters({
                qty,
              });
            }}
            warning={errors.qty}
          />
        </div>
        <div className="col-12">
          <TextInputModal
            disabled={parameters.price_from_pim}
            text="Price"
            value={parameters.price}
            required={true}
            onChange={(e) => {
              const price = e.target.value;
              setParameters({
                price,
              });
            }}
            warning={errors.price}
          />
        </div>
        <div className="col-12 mt-2">
          <CheckBoxInput
            onChange={() => {
              setParameters({
                price_from_pim: !parameters.price_from_pim,
              });
            }}
            checked={parameters.price_from_pim}
            text="Take new price from PIM"
          />
        </div>
      </div>
    </div>
  );
};

const ChangeCourier = ({ parameters, setParameters, order_shop_id }) => {
  let filterParams = "";
  if (order_shop_id) {
    order_shop_id.forEach((d) => {
      filterParams += `&q[order_shop_id_in][]=${d}`;
    });
  }
  const { value, loading, error } = useFetch(
    `/api/v1/carriers/active?&q[order_shop_id_null]=0&q[identifier_cont]=_home${filterParams}`,
    {},
    [order_shop_id]
  );
  if (error) return <div>{JSON.stringify(error)}</div>;
  if (loading) return <LoadingComp />;
  return (
    <div>
      <SelectInput
        with_empty={false}
        label="Change to"
        placeholder="Select"
        options={value.map((d) => ({
          label: d.title || d.name,
          value: d.id,
        }))}
        value={parameters.carrier_id || undefined}
        onChange={(carrier_id) =>
          setParameters({
            carrier_id,
          })
        }
      />
      <TextInputModal
        text="Weight from (kg)"
        value={parameters.weight_from}
        required={false}
        onChange={(e) => {
          const weight_from = e.target.value;
          setParameters({
            weight_from,
          });
        }}
      />
    </div>
  );
};

const CommentState = ({ parameters, setParameters }) => {
  const [selectedCommentType, setSelectedCommentType] = useState(null);
  const [options, setOptions] = useState([]);
  const initialLoad = useRef(true);

  const [fetchUrl, setFetchUrl] = useState(
    `/api/v1/comment_states/search_by_type`
  );

  const { value, loading, error, setReFetch } = useFetch(fetchUrl);

  useEffect(() => {
    if (selectedCommentType) {
      setFetchUrl(
        `/api/v1/comment_states/search_by_type?[q][comment_type_eq]=${selectedCommentType.value}`
      );
      setReFetch();

      const commentStatesForType = value?.filter(
        (d) => d.comment_type === selectedCommentType.value
      );

      if (commentStatesForType && commentStatesForType.length > 0) {
      } else {
        setParameters({ comment_state_id: undefined });
      }
      setParameters({ comment_type: selectedCommentType?.value });
    }
  }, [selectedCommentType]);

  useEffect(() => {
    if (value?.length > 0 && options?.length === 0) {
      const uniqueCommentTypes = Array.from(
        new Set(value.map((d) => d.comment_type))
      ).filter((type) => type !== "comment_tch_pickup");

      const initialOptions = uniqueCommentTypes.map((type) => ({
        value: type,
        label: type
          .split("_")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
      }));

      setOptions(initialOptions);
    }
  }, [value, options?.length]);

  useEffect(() => {
    if (
      value?.length > 0 &&
      !selectedCommentType &&
      initialLoad.current &&
      parameters.comment_state_id === undefined
    ) {
      setSelectedCommentType({
        value: "comment_management",
        label: "Comment Management",
      });
      initialLoad.current = false;
    }
  }, [value]);

  useEffect(() => {
    if (selectedCommentType) {
      const firstCommentState = value?.find(
        (d) => d.comment_type === selectedCommentType.value
      );
      if (
        firstCommentState &&
        parameters.comment_state_id !== firstCommentState.id
      ) {
        setParameters((prevParams) => ({
          ...prevParams,
          comment_state_id: firstCommentState.id,
        }));
      }
    }
  }, [selectedCommentType, value]);

  useEffect(() => {
    if (parameters.comment_state_id !== undefined) {
      const commentState = value?.find(
        (d) => d.id === parameters.comment_state_id
      );
      if (
        commentState &&
        selectedCommentType?.value !== commentState.comment_type
      ) {
        setSelectedCommentType({
          value: commentState.comment_type,
          label: commentState.comment_type
            .split("_")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
        });
      }
    }
  }, [parameters.comment_state_id, value]);
  console.log(selectedCommentType, "selectedOption");

  if (error) return <div>{JSON.stringify(error)}</div>;
  if (loading) return <LoadingComp />;

  return (
    <div>
      <SelectInput
        options={options}
        value={options.find(
          (option) => option.value === selectedCommentType?.value
        )}
        onChange={(value) => {
          const selectedOption = options.find(
            (option) => option.value === value
          );
          setSelectedCommentType(selectedOption);
        }}
      />
      <div className="my-2">
        <SelectInput
          options={value
            .filter((d) => d.comment_type === selectedCommentType?.value)
            .map((d) => ({
              label: d.name,
              value: d.id,
            }))}
          value={parameters.comment_state_id}
          placeholder="Comment type"
          onChange={(comment_state_id) => {
            setParameters({ comment_state_id });
          }}
        />
      </div>
      <TextAreaFieldGroup
        value={parameters.message}
        onChange={(e) => {
          const message = e.target.value;
          setParameters({ message });
        }}
      />
    </div>
  );
};

const CommentNote = ({ parameters, setParameters }) => {
  const { value, loading, error } = useFetch("/api/v1/suppliers");
  if (error) return <div>{JSON.stringify(error)}</div>;
  if (loading) return <LoadingComp />;
  return (
    <div className="d-flex flex-column">
      <div className="my-2">
        <SelectInput
          placeholder="Suppliers"
          mode="multiple"
          options={value.data.map((d) => ({
            label: d.title || d.name,
            value: d.id,
          }))}
          value={parameters.supplier_ids || undefined}
          onChange={(supplier_ids) =>
            setParameters({
              supplier_ids,
            })
          }
        />
      </div>
      <TextAreaFieldGroup
        value={parameters.message}
        onChange={(e) => {
          const message = e.target.value;
          setParameters({ message });
        }}
      />
      <p>
        <small>
          Keywords:
          <ul>
            <li>[SKU] - product SKU</li>
            <li>[product_code] - supplier product code</li>
            <li>[supplier_code] - supplier code</li>
            <li>[delivery] - delivery time</li>
          </ul>
        </small>
      </p>
    </div>
  );
};

const AddSupplying = ({ parameters, setParameters }) => {
  const { value, loading, error } = useFetch("/api/v1/suppliers");
  if (error) return <div>{JSON.stringify(error)}</div>;
  if (loading) return <LoadingComp />;
  return (
    <div className="d-flex flex-column">
      <div className="d-flex align-items-center">
        <TextInputModal
          placeholder="Qty"
          value={parameters.qty}
          onChange={(e) => {
            const qty = e.target.value;
            setParameters({
              qty,
            });
          }}
        />
        <div className="mx-2" />
        <SelectInput
          placeholder="Suppliers"
          options={value.data.map((d) => ({
            label: d.title || d.name,
            value: d.id,
          }))}
          value={parameters.supplier_id || undefined}
          onChange={(supplier_id) =>
            setParameters({
              supplier_id,
            })
          }
        />
      </div>
      <TextInputModal
        placeholder="Day"
        value={parameters.days}
        onChange={(e) => {
          const days = e.target.value;
          setParameters({
            days,
          });
        }}
      />
    </div>
  );
};

const AdditionalGood = ({ parameters, setParameters, order_shop_id }) => {
  const [collapse, setCollapse] = useState(null);

  // instantly update the parameters
  const onChangeHandler = (val, idx) => {
    let obj = { ...parameters };
    obj.data[idx] = {
      ...obj.data[idx],
      ...val,
    };
    setParameters(obj);
  };

  // instantly remove the parameters
  const onHandlerRemove = (idx) => {
    if (!confirm("Are you sure you want to remove?")) return;
    let obj = { ...parameters };
    obj.data.splice(idx, 1);
    setCollapse(obj);
    if (collapse == idx) return setCollapse(collapse == 0 ? 0 : collapse - 1);
  };

  // for add new one
  const onHandlerAdd = (val) => {
    setParameters({
      data: [...parameters.data, val],
    });
    // because will be + 1
    setCollapse(parameters.length);
  };

  return (
    <div className="bg-white">
      {parameters?.data?.map((d, idx) => (
        <AlreadyExistAdditionalGood
          idx={idx}
          key={`additiona_good_${idx}`}
          its_collapsed={collapse == idx}
          setCollapse={() => setCollapse(collapse == idx ? null : idx)}
          parameters={d}
          setParameters={(val) => onChangeHandler(val, idx)}
          order_shop_id={order_shop_id}
          onHandlerRemove={() => onHandlerRemove(idx)}
        />
      ))}

      <AutosysAdditionalGoodBottomNew
        order_shop_id={order_shop_id}
        onHandlerAdd={onHandlerAdd}
        collapse={collapse}
        setCollapse={setCollapse}
      />
    </div>
  );
};

const AutosysAdditionalGoodBottomNew = ({
  order_shop_id,
  onHandlerAdd,
  collapse,
  setCollapse,
}) => {
  const [variables, setVariables] = useState(initialStateVariables);

  const editing = collapse == "editing";
  const available = useMemo(() => {
    if (!editing) return true;
    if (!variables.product_name) return false;
    if (variables.product_price === "" || variables.product_price === null || variables.product_price === undefined) return false;
    if (!variables.quantity) return false;

    return true;
  }, [
    variables.product_name,
    variables.product_price,
    variables.quantity,
    editing,
  ]);

  const onChangeHandler = (val) => {
    setVariables((prev) => ({
      ...prev,
      ...val,
    }));
  };
  return (
    <div>
      {editing && (
        <AutosysAdditionalGoodNew
          order_shop_id={order_shop_id}
          parameters={variables}
          setParameters={onChangeHandler}
        />
      )}

      <div className="d-flex align-items-center justify-content-between">
        <div
          className="text-xss cursor-pointer"
          style={{
            color: available || !editing ? "#03B0F7" : "#BFBFBF",
          }}
          onClick={() => {
            if (editing) {
              if (available) {
                const addGood = () => {
                  onHandlerAdd(variables);
                  setVariables(initialStateVariables);
                };
                if (Number(variables.product_price) === 0) {
                  AntdConfirm({
                    title: "Are you sure you want to add a product with 0 price?",
                    content: "",
                    onOk: addGood,
                  });
                } else {
                  addGood();
                }
              }
            } else {
              setCollapse("editing");
            }
          }}
        >
          <AiFillPlusCircle
            color={available || !editing ? "#03B0F7" : "#BFBFBF"}
          />
          <span className="pl-2">Add extra good</span>
        </div>
        {editing && (
          <IconTrash
            onClick={() => {
              // setEditing(null);
              setVariables(initialStateVariables);
              setCollapse(null);
            }}
          />
        )}
      </div>
    </div>
  );
};

const AlreadyExistAdditionalGood = ({
  idx,
  its_collapsed,
  setCollapse,
  order_shop_id,
  parameters,
  setParameters,
  onHandlerRemove,
}) => {
  console.log({ its_collapsed });

  const styles = its_collapsed
    ? {
      position: "absolute",
      top: 0,
      right: 0,
      zIndex: 1000000,
    }
    : {};
  return (
    <div className="position-relative">
      <div
        className="d-flex justify-content-between py-1"
        style={{
          ...styles,
          borderTop: idx == 0 ? "none" : "1px solid #F2F2F2",
        }}
      >
        <h3 className="text-black text-sm font-weight-bold mb-0">
          {!its_collapsed && parameters.product_name}
        </h3>
        <div className="d-flex align-items-center justify-content-end">
          <div>
            <IconTrash onClick={onHandlerRemove} />
          </div>
          <div className="ml-3 cursor-pointer" onClick={() => setCollapse()}>
            {its_collapsed ? <IconChevronDownSolid /> : <IconChevronUpSolid />}
          </div>
        </div>
      </div>
      {its_collapsed && (
        <AutosysAdditionalGoodNew
          showBorder={idx == 0 ? false : true}
          order_shop_id={order_shop_id}
          parameters={parameters}
          setParameters={setParameters}
        />
      )}
    </div>
  );
};

const AutosysAdditionalGoodNew = ({
  parameters,
  setParameters,
  order_shop_id,
  showBorder = true,
}) => {
  const { value, loading, error } = useFetch("/api/v1/suppliers");
  if (error) return <div>{JSON.stringify(error)}</div>;
  if (loading) return <LoadingComp />;

  const fetchOptions = async (value) => {
    try {
      console.log("call");
      let filterParams = "";
      if (order_shop_id) {
        order_shop_id.forEach((d) => {
          filterParams += `&q[order_shop_id_or_order_shops_id_in][]=${d}`;
        });
      }
      let api_url = `/api/v1/rivile_services?page=1&per_page=9999999&q[title_i_cont_any]=${value}${filterParams}`;
      if (parameters.type == "goods") {
        api_url = `/api/v1/products/meilisearch_products.json?q[title_or_identifier_i_cont_any]=${value}`;
      }

      const { data } = await Axios.get(api_url);
      return (
        data?.data?.map((e) => ({
          ...e,
          value: e.identifier || e.id,
          label: `${e.identifier || e.rivile_code} - ${e.title}`,
        })) || []
      );
    } catch (err) {
      errorHandler(err);
      return [];
    }
  };

  const changeType = (type) => {
    setParameters({
      ...initialStateVariables,
      type,
    });
  };
  return (
    <React.Fragment>
      <div
        className="col-12 px-0 pt-2 pb-3"
        style={{
          borderTop: showBorder ? "1px solid #F2F2F2" : "none",
        }}
      >
        <div className="d-flex flex-column">
          <Checkbox
            checked={parameters.type == "goods"}
            onChange={() => changeType("goods")}
          >
            Product search
          </Checkbox>
          <div>
            <Checkbox
              checked={parameters.type == "service"}
              onChange={() => changeType("service")}
            >
              Service search
            </Checkbox>
          </div>
          {/* <div>
            <Checkbox
              checked={parameters.type == "other"}
              onChange={() => changeType("other")}
            >
              Other
            </Checkbox>
          </div> */}
        </div>
        {/*  */}
        {/* <div className="mt-3"></div> */}
        {parameters.type !== "other" && (
          <DebounceSelect
            showSearch={true}
            // mode="multiple"
            value={undefined}
            // value={parameters.id}
            placeholder={`Select ${parameters.type == "goods" ? "product" : "service"
              }...`}
            fetchOptions={fetchOptions}
            onChange={(_, newValue) => {
              setParameters({
                ...initialStateVariables,
                id: newValue.id,
                type: parameters.type,
                quantity: 1,
                product_name: newValue.title,
                product_price:
                  newValue.product_price || newValue.alt_price || 0,
                product_reference: newValue.identifier || "",
                barcode: "",
                id_product: newValue?.id_product || "",
                rivile_code: newValue?.rivile_code || "",
              });
            }}
            style={{
              width: "100%",
            }}
          />
        )}
        <React.Fragment>
          <div className="d-flex">
            <div style={{ width: "50%" }}>
              <TextInputModal
                required={true}
                text="Name"
                placeholder="Enter"
                value={parameters.product_name}
                onChange={(e) =>
                  setParameters({ product_name: e.target.value })
                }
              // warning={errors.title}
              />
            </div>
            <div className="px-1" style={{ width: "25%" }}>
              <TextInputModal
                required={true}
                type="number"
                text="Quantity"
                placeholder="Enter"
                value={parameters.quantity}
                onChange={(e) => setParameters({ quantity: e.target.value })}
              />
            </div>
            <div style={{ width: "25%" }}>
              <TextInputModal
                required={true}
                type="number"
                text="Price"
                placeholder="Enter"
                value={parameters.product_price}
                onChange={(e) =>
                  setParameters({ product_price: e.target.value })
                }
              />
            </div>
            {parameters.type == "other" && (
              <div className="pl-1" style={{ width: "50%" }}>
                <TextInputModal
                  text="Barcode"
                  placeholder="Enter"
                  value={parameters.barcode}
                  onChange={(e) => setParameters({ barcode: e.target.value })}
                />
              </div>
            )}
          </div>

          {parameters.type == "goods" && (
            <>
              <div className="row">
                <div className="col-4 pr-1">
                  <TextInputModal
                    text="Supplier qty"
                    value={parameters.supplier_qty}
                    onChange={(e) => {
                      const supplier_qty = e.target.value;
                      setParameters({
                        supplier_qty,
                      });
                    }}
                  />
                </div>
                <div className="col-4 px-1">
                  <SelectInput
                    label="Supplier"
                    options={value.data.map((d) => ({
                      label: d.title || d.name,
                      value: d.id,
                    }))}
                    value={parameters.supplier_id}
                    onChange={(supplier_id) =>
                      setParameters({
                        supplier_id,
                      })
                    }
                  />
                </div>
                <div className="col-4 pl-1">
                  <TextInputModal
                    text="Days"
                    value={parameters.days}
                    onChange={(e) => {
                      const days = e.target.value;
                      setParameters({
                        days,
                      });
                    }}
                  />
                </div>
              </div>
            </>
          )}
        </React.Fragment>
      </div>
    </React.Fragment>
  );
};

const LoadingComp = () => (
  <div className="d-flex align-items-center justify-content-center my-2">
    <Spin />
  </div>
);

const ApplyActionItemStyled = styled.div`
  background: #fff;
  border: 1px solid ${(props) => (props.active ? "#03B0F7" : "#d9d9d9")};
  border-radius: 4px;
  .block-header {
    background: #edf9fe;
    border-bottom: 1px solid #03b0f7;
    border-radius: 4px 4px 0px 0px;
  }
`;

export default AutosysApplyAction;
